module.exports = __webpack_public_path__ + "static/media/close.244ab72b.svg";